import { DataAttributeDefinitions, provideDataClass } from 'scrivito'

import { DataClassName, PisaDataClassEndpoint } from '@/Data/const'
import { createPisaRestApiConfig } from '@/Data/pisaClient'

const contactProjectDataClassName = DataClassName.CONTACT_PROJECT_RELATION
const contactProjectEndpoint = PisaDataClassEndpoint.CONTACT_PROJECT

export function pisaContactProjectRelationDataClass(
  attributes: DataAttributeDefinitions,
) {
  return provideDataClass(contactProjectDataClassName, {
    title: contactProjectDataClassName,
    restApi: createPisaRestApiConfig(contactProjectEndpoint),
    attributes,
  })
}
